<div class="cm-inspector-content">
    @if ($node(); as instance) {
        <cm-inspector-section>
            <ng-container cm-content>
                <cm-value-slot [node]="instance" [key]="'name'" [label]="'Name'"></cm-value-slot>
                <cm-value-slot [node]="instance" [key]="'id'" [label]="'Id'"></cm-value-slot>
                <cm-value-slot [node]="instance" [key]="'graph'" [label]="'Graph'"></cm-value-slot>
            </ng-container>
        </cm-inspector-section>

        <cm-mattress-component-instance-interface-inspector
            [componentDescriptors]="$componentDescriptors()"
            [templateDescriptors]="$templateDescriptors()"
            [node]="instance"
            [inputParameterProvider]="$inputParameterProvider()"
            [wrappedInstanceId]="$wrappedInstanceId()"
            (updateComponentInstanceParameter)="updateOverwrittenValue($event.key, $event.value)"
            (componentInstanceOutputItemClicked)="addInstanceOutputToParentGraph($event)"
        ></cm-mattress-component-instance-interface-inspector>

        <cm-button class="cm-action-button" (click)="clearInstanceParametersParameters()">
            <ng-container cm-text> Clear Parameters </ng-container>
        </cm-button>
    }
</div>
